import { render, staticRenderFns } from "./ScoreCircle.vue?vue&type=template&id=6fd16e04&scoped=true&"
import script from "./ScoreCircle.vue?vue&type=script&lang=js&"
export * from "./ScoreCircle.vue?vue&type=script&lang=js&"
import style0 from "./ScoreCircle.vue?vue&type=style&index=0&id=6fd16e04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd16e04",
  null
  
)

export default component.exports